
import { defineComponent } from 'vue';
import {
  Button, Input, Select, Spin,
} from 'ant-design-vue';
import myEmpty from '@/components/myEmpty.vue';
import SceneBox from '@/components/teacher/sceneConstruct/sceneBox.vue';
import SceneEditBox from '@/components/teacher/sceneConstruct/sceneEditBox.vue';
import sceneDesignMainHeader from '@/components/teacher/sceneConstruct/sceneDesignMainHeader.vue';
import departmentalCapacity from '@/components/teacher/sceneConstruct/departmentalCapacity.vue';
import teamTable from '@/components/teacher/sceneConstruct/teamTable.vue';
import suppliesTable from '@/components/teacher/sceneConstruct/suppliesTable.vue';
import asynButtonVue from '@/components/asynButton.vue';
import roleInfoModuleFn from './js/roleInfo';

const component = defineComponent({
  name: '',
  components: {
    myEmpty,
    SceneBox,
    SceneEditBox,
    sceneDesignMainHeader,
    departmentalCapacity,
    teamTable,
    suppliesTable,
    aButton: asynButtonVue,
    aInput: Input,
    aSelect: Select,
    aSelectOption: Select.Option,
    aSpin: Spin,
  },
  props: {
    headerText: {
      type: String,
      default: '',
    },
    caseId: {
      type: String,
      default: '',
      require: true,
    },
  },
  setup(props, context) {
    const roleInfoModule = roleInfoModuleFn(context, props.caseId);
    return {
      props,
      roleInfoModule,
    };
  },
});

export default component;
